<template>
    <div class="page" ref="appFormula">
        <router-stage></router-stage>
        <div ref="boxTop" class="box-top"></div>
        <!-- <div class="scroll" ref="scroll"> -->
        <img src="https://oss.eventnet.cn/H5/72Hours/pc/logo.png" class="logo">
        <div class="hours"></div>
        <div class="slogan"></div>
        <!-- End -->
        <img src="https://oss.eventnet.cn/H5/72Hours/image/pc/title-demo.png" class="title-demo">
        <ul class="game-list">
            <li v-for="(item, index) in formulaList1" :key="index" v-show="formulaList1.length > 0">
                <img :src="item.image" alt="">
                <div class="title">{{ item.title }}</div>
            </li>
        </ul>
        <img src="https://oss.eventnet.cn/H5/72Hours/image/pc/title-originality.png" class="title-originality">
        <ul class="game-list">
            <li v-for="(item, index) in formulaList2" :key="index" v-show="formulaList2.length > 0">
                <img :src="item.image" alt="">
                <div class="title">{{ item.title }}</div>
            </li>
        </ul>

        <div class="user-html" v-show="userAgreement">
            <div class="user-iframe">
                <div class="user-scroll">
                    <user-agreement></user-agreement>
                </div>
                <div class="user-close iconfont icon-guanbi1" @click="userAgreement = false; isUser = true"></div>
            </div>

        </div>

        <!-- 投票弹窗 -->
        <div class="vote-popup" v-show="votePopup">
            <div class="vote-close iconfont icon-guanbi1" @click="voteClose"></div>
            <div class="vote-main">
                <div class="vote-container">
                    <!-- <img src="https://oss.eventnet.cn/H5/72Hours/image/seize.jpg" alt=""> -->
                    <div class="vote-image">
                        <img :src="voteContent.image" v-if="!isSwiper">
                        <Swiper :bannerArr="imageArr" v-if="isSwiper"></Swiper>
                    </div>
                    <div class="vote-content">
                        <p>
                            <span>游戏名称:</span>
                            {{ voteContent.title }}
                        </p>
                        <p>
                            <span v-show="voteContent.track == '1'">标签:</span>
                            <span v-show="voteContent.track == '2'">游戏类型:</span>
                            {{ voteContent.type }}
                        </p>
                        <p>
                            <span v-show="voteContent.track == '1'">游戏简介:</span>
                            <span v-show="voteContent.track == '2'">游戏世界观设定:</span>
                            {{ voteContent.introduction }}
                        </p>
                        <p>
                            <span v-show="voteContent.track == '1'">游戏平台:</span>
                            <span v-show="voteContent.track == '2'">角色设定:</span>
                            {{ voteContent.setting }}
                        </p>
                        <p>
                            <span v-show="voteContent.track == '1'">安装及试玩方法:</span>
                            <span v-show="voteContent.track == '2'">游戏核心机制:</span>
                            {{ voteContent.core }}
                        </p>
                        <p v-show="voteContent.track == '1'">
                            <span>下载地址:</span>
                            <a :href="voteContent.down" target="_blank"> {{ voteContent.down }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { is_mobile } from '../Toolset'
export default {
    name: "Index",
    data() {
        return {
            isMac: false, // 是否苹果系统，倒计时文字高度上下居中
            gameList: [
                {
                    title: 'AKA进击的巨人的巨人AKA进击巨人的巨人',
                    image: 'https://oss.eventnet.cn/H5/72Hours/image/seize.jpg',
                    vote: '6666'
                }, {
                    title: 'AKA进击的巨人的巨人',
                    image: 'https://oss.eventnet.cn/H5/72Hours/image/seize.jpg',
                    vote: '6666'
                }
            ],
            openid: null,
            userAgreement: false,
            formulaList1: [],
            formulaList2: [],
            votePopup: false,
            imageArr: [],
            isSwiper: false,
            voteContent: {
                arrId: '', // 当前文章所在列表的坐标
                uuid: '', // 用户id
                track: '2', // 所属赛道
                image: '', // 图片
                title: '', // 游戏名称
                type: '', // 标签、游戏类型
                introduction: '', // 游戏简介、游戏世界观设定
                setting: '', // 游戏平台、角色设定
                core: '', // 安装及试玩方法、游戏核心机制
                down: '' // 全栈赛道
            },
        };
    },
    created() {
        const THAT = this;
        if (is_mobile()) {
            console.log('😁是否手机端33', is_mobile());
            THAT.$router.replace("/MFormula");
        }
        THAT.openid = localStorage.getItem('hose72-wwx3-2wzf-uuid') || null;
        THAT.formulaApi();
    },
    mounted() {
        const THAT = this;
        THAT.$refs.appFormula.scrollIntoView();
    },
    methods: {
        formulaApi() {
            const THAT = this;
            THAT.axios
                .post('Works/final/')
                .then(res => {
                    console.log('发布成功 ====>>>', res.data);
                    if (res.data.code == 200) {
                        for (let i = 0; i < res.data.data.length; i++) {
                            // console.log(res.data.data[i]);
                            let formulaObj1 = {
                                image: res.data.data[i].image.split('||')[0],
                                number: res.data.data[i].number,
                                title: res.data.data[i].title,
                                uuid: res.data.data[i].uuid
                            }
                            THAT.formulaList1.push(formulaObj1);
                        }
                        for (let i = 0; i < res.data.data2.length; i++) {
                            // console.log(res.data.data[i]);
                            let formulaObj2 = {
                                image: res.data.data2[i].image.split('||')[0],
                                number: res.data.data2[i].number,
                                title: res.data.data2[i].title,
                                uuid: res.data.data2[i].uuid
                            }
                            THAT.formulaList2.push(formulaObj2);
                        }
                    }

                })
                .catch(error => {
                    console.log(error);
                    // console.log(error.response);
                });
        },
        gamePop(type, uuid, index) {
            const THAT = this;
            THAT.openid = localStorage.getItem('hose72-wwx3-2wzf-uuid') || null;
            // console.log(THAT.openid, '||', type, uuid);
            if (THAT.openid == null) {
                // console.log('请登录');
                THAT.reget();
                return false;
            }
            /* 已登录 */
            // 2 9ZQ8VD94X3WOGNJVWNY7ER5KP16M0J
            let workData = new FormData();
            workData.append("type", type);
            workData.append("uuid", uuid);
            THAT.axios
                .post('Works/info/', workData)
                .then(res => {
                    if (res.data.code == 200) {
                        let gameWorks = res.data.data;
                        // console.log('😂发布成功 ====>>>', gameWorks);
                        // console.log('😂发布成功 ====>>>', gameWorks.image.split('||'));
                        THAT.imageArr = gameWorks.image.split('||');
                        THAT.voteContent.uuid = uuid; // 用户id
                        THAT.voteContent.track = type; // 所属赛道
                        THAT.voteContent.image = THAT.imageArr[0]; // 图片
                        THAT.voteContent.arrId = index;
                        if (THAT.imageArr.length > 1) {
                            THAT.isSwiper = true;
                        }
                        if (type == '1') {
                            THAT.voteContent.title = gameWorks.title; // 游戏名称
                            THAT.voteContent.type = gameWorks.type; // 标签、游戏类型
                            THAT.voteContent.introduction = gameWorks.introduction; // 游戏简介、游戏世界观设定
                            THAT.voteContent.setting = gameWorks.platform; // 游戏平台、角色设定
                            THAT.voteContent.core = gameWorks.readme; // 安装及试玩方法、游戏核心机制
                            THAT.voteContent.down = gameWorks.download; // 全栈赛道
                        }
                        if (type == '2') {
                            THAT.voteContent.title = gameWorks.title; // 游戏名称
                            THAT.voteContent.type = gameWorks.type; // 标签、游戏类型
                            THAT.voteContent.introduction = gameWorks.setup1; // 游戏简介、游戏世界观设定
                            THAT.voteContent.setting = gameWorks.setup2; // 游戏平台、角色设定
                            THAT.voteContent.core = gameWorks.introduction; // 安装及试玩方法、游戏核心机制
                            THAT.voteContent.down = ''; // 全栈赛道
                        }

                        THAT.votePopup = true;
                    }
                })
                .catch(error => {
                    console.log(error);
                    // console.log(error.response);
                });
        },
        voteClose() {
            const THAT = this;
            THAT.votePopup = false;
            THAT.isSwiper = false;
            THAT.voteContent.arrId = '';
            THAT.voteContent.uuid = ''; // 用户id
            THAT.voteContent.track = ''; // 所属赛道
            THAT.voteContent.image = ''; // 图片
            THAT.voteContent.title = ''; // 游戏名称
            THAT.voteContent.type = ''; // 标签、游戏类型
            THAT.voteContent.introduction = ''; // 游戏简介、游戏世界观设定
            THAT.voteContent.setting = ''; // 游戏平台、角色设定
            THAT.voteContent.core = ''; // 安装及试玩方法、游戏核心机制
            THAT.voteContent.down = ''; // 全栈赛道
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    position: relative;
    min-width: 1118px;
    background: url('https://oss.eventnet.cn/H5/72Hours/pc/bg.jpg') top center no-repeat;
    background-size: 1920px 12191px;
    padding-top: 723px;
    padding-bottom: 800px;

    div {
        margin: auto;
    }

    .box-top {
        position: absolute;
        top: 411px;
        left: 0;
        z-index: 2;
        // border: solid 5px yellow;
        width: 50px;
        height: 50px;
    }

    .logo {
        position: absolute;
        top: 211px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
        pointer-events: none;
    }

    .hours {
        position: absolute;
        top: 60px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        width: 1920px;
        height: 1451px;
        background: url('https://oss.eventnet.cn/H5/72Hours/pc/72-hours.png') no-repeat;
        background-size: 100% 100%;

        .hours-cerebrum {
            position: absolute;
            top: 354px;
            left: calc(50% + 8px);
            transform: translateX(-50%);
            width: 774px;
            // border: solid 10px yellow;

            .cls-1,
            .cls-3 {
                fill: none;
                stroke: #2afcf5;
                stroke-miterlimit: 10;
                stroke-width: 1.5
            }

            .cls-3 {
                stroke: #fff;
            }
        }
    }

    .slogan {
        position: relative;
        z-index: 2;
        width: 891px;
        height: 1421px;
        background: url('https://oss.eventnet.cn/H5/72Hours/pc/slogan2.png') center no-repeat;
        background-size: 100% 100%;
    }



    .title-demo,
    .title-originality {
        width: 1140px;
        height: 408px;
        margin: 45px auto 75px;
        pointer-events: none;
    }

    .title-originality {
        height: 407px;
        margin-top: 5px;
    }





    .game-list {
        width: 880px;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        li {
            width: 880px;
            margin-bottom: 50px;
            // cursor: pointer;

            img {
                width: 880px;
                height: 466px;
                display: block;
                border: solid 7px #34f2ec;
            }

            .title {
                padding: 20px 5px;
                font-size: 44px;
                line-height: 1.5;
                text-align: center;
            }
        }
    }
}

.page::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 550px;
    display: block;
    // border: solid 5px yellow;
    background: url('https://oss.eventnet.cn/H5/72Hours/image/pc/bg-footer.png') bottom center no-repeat;
    background-size: 1316px 550px;
}

.vote-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1111;
    background: #00036b url('https://oss.eventnet.cn/H5/72Hours/pc/bg-page2.jpg') top center no-repeat;
    background-size: 100% auto;

    .vote-close {
        position: absolute;
        top: 50px;
        right: 50px;
        z-index: 2;
        width: 50px;
        height: 50px;
        font-size: 34px;
        line-height: 50px;
        text-align: center;
        // border: solid 5px yellow;
        background-color: #fff;
        color: #000;
        cursor: pointer;
    }

    .vote-main {
        position: relative;
        z-index: 1;
        width: 100%;
        min-height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
        margin: auto;
        padding-top: 120px;
        padding-bottom: 120px;
        // border: solid 5px yellow;

        .vote-container {
            position: relative;
            width: 1200px;
            min-height: 100%;
            padding-bottom: 85px;


            .vote-image {
                position: absolute;
                top: 0;
                left: 0;
                width: 540px;
                height: 291px;
                background-color: #fff;
                margin-bottom: 85px;

                img {
                    max-width: 540px;
                    height: 291px;
                    display: block;
                    margin: auto;
                }
            }

            .vote-content {
                width: 100%;
                min-height: 354px;
                padding-left: 600px;

                p {
                    position: relative;
                    z-index: 3;
                    margin-bottom: 10px;
                    font-size: 22px;
                    line-height: 1.5;
                    color: #dddde7;

                    span {
                        background-color: #27e7dc;
                        margin-right: 10px;
                        padding: 4px 10px;
                        font-weight: bold;
                        color: #00036b;
                    }

                    a {
                        color: #dddde7;
                    }
                }
            }

            .vote-submit {
                position: relative;
                z-index: 3;
                width: 240px;
                height: 80px;
                background: url('https://oss.eventnet.cn/H5/72Hours/image/mobile/vote-submit.png') center no-repeat;
                background-size: 199px 62px;
                margin: 85px auto 0;
                cursor: pointer;
            }

            .vote-submit:active {
                top: 1px;
                left: 1px;
            }
        }
    }
}

.vote-popup::before {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    z-index: 1;
    display: block;
    width: 1365px;
    height: 563px;
    background: url('https://oss.eventnet.cn/H5/72Hours/pc/page-bottom.png') top no-repeat;
    background-size: 1365px 563px;
}
</style>



// WEBPACK FOOTER //
// src/components/Formula.vue